import { useMemo } from 'react';
import { InvoiceService } from 'api';
import { MailReqBody } from 'api/invoices/invoices.types';
import { isSuccessful } from 'api/utils';
import { SendMailDialog } from 'components/SendMailDialog';
import { CorrectiveInvoice, Invoice } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';
import { isInvoiceCorrective } from 'utils/invoiceFunctions.utils';
import { appToast } from 'utils/toast.utils';

interface Props {
  invoice: Invoice | CorrectiveInvoice;
  isOpen: boolean;
  onClose: () => void;
}

export const InvoiceSendMailDialog = ({ invoice, isOpen, onClose }: Props) => {
  const { t } = useTranslation(['mail', 'invoice']);
  const { data, loading, getMailStub } = InvoiceService.useGetMailStub();
  const { loading: isSendLoading, sendMail } = InvoiceService.useSendMail();

  const isCorrectiveInvoice = useMemo(
    () => isInvoiceCorrective(invoice.invoiceClass),
    [invoice],
  );

  const getInvoiceMailStub = () =>
    getMailStub(Number(invoice.id), isCorrectiveInvoice);

  const handleSendMail = (data: MailReqBody) => {
    sendMail(data, Number(invoice.id), isCorrectiveInvoice).then((res) => {
      if (isSuccessful(res)) {
        appToast.success(t('successMessage', { ns: 'mail' }));
        onClose();
      }
    });
  };

  return (
    <SendMailDialog
      header={
        t('header', { ns: 'mail' }) +
        ' - ' +
        t('invoice', { ns: 'invoice' }) +
        ' ' +
        invoice.code
      }
      isOpen={isOpen}
      onOpen={getInvoiceMailStub}
      isLoading={loading}
      mailStub={data}
      onSend={handleSendMail}
      isSendLoading={isSendLoading}
      onClose={onClose}
      counterpartyIds={invoice.buyerCounterparty.id}
    />
  );
};
